import { render, staticRenderFns } from "./SettingsIndexes.vue?vue&type=template&id=527f5cb8&scoped=true&"
import script from "./SettingsIndexes.vue?vue&type=script&lang=js&"
export * from "./SettingsIndexes.vue?vue&type=script&lang=js&"
import style0 from "./SettingsIndexes.vue?vue&type=style&index=0&id=527f5cb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527f5cb8",
  null
  
)

export default component.exports